import { Field, useField } from "formik";
import React from "react";
import FormField from "./FormField";

const CheckboxField = ({ name, label, value, ...rest }) => {
  const [, meta] = useField(name);

  return (
    <FormField label="" name={name}>
      <label className="flex items-start gap-2">
        <Field
          type="checkbox"
          name={name}
          className={`mt-1 h-4 w-4 rounded text-primary focus:ring-primary ${meta.touched && meta.error ? "border-red-500" : "border-gray-300"}`}
          {...rest}
        />
        <span className="flex-1">{label}</span>
      </label>
    </FormField>
  );
};

export default CheckboxField;
